import { createPinia as createPiniaOrigin } from 'pinia';
import { PiniaLogger } from 'pinia-logger';

import { LoadingHandlerPiniaPlugin, SentryMonitoringPlugin, TranslatableErrorHandlerPiniaPlugin } from './plugins';

export { default as useAuth } from './auth';
export { default as useQueuesStore } from './queues';

function createPinia() {
  return createPiniaOrigin()
    .use(PiniaLogger({
      expanded: false,
      disabled: process.env.NODE_ENV === 'production',
    }))
    .use(LoadingHandlerPiniaPlugin)
    .use(TranslatableErrorHandlerPiniaPlugin)
    .use(SentryMonitoringPlugin({
      disabled: process.env.NODE_ENV === 'development',
      ignore: ['auth'],
    }));
}

export default createPinia;
